import React, { useCallback, useEffect, useState } from 'react';

import api from '../../../services/api';

import { GraduationCap, House, MagnifyingGlass } from 'phosphor-react';

import LoaderBIO from '../../../components/Loader';
import Breadcrumbs from '../../../components/Breadcrumbs';
import InputDebounceAdapter from '../../../components/InputDebounceAdapter';
import HeaderSectionContainer from '../../../components/HeaderSectionContainer';
import NotFoundRegister from '../../../components/NotFoundRegister';
import Pagination from '../../../components/Pagination';

import {
  Container,
  HeaderSection,
  SectionContainer1,
  SearchContainer,
} from './styles';

import { IClusterProps } from '../../../interfaces/Cluster';
import { CardUniversity } from '../../admin/ModulosExercisesInVideo/styles';
//@ts-ignore
import ProgressBar from 'react-animated-progress-bar';

export interface IPaginationProps {
  page: number;
  maxPages: number;
  showingFrom: number;
  showingTo: number;
  totalRecords: number;
  records?: IClusterProps[];
}

const scrollRef = document.querySelector('#main-scroll');

const ModulosExercisesInVideo: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [clustersData, setClustersData] = useState<IPaginationProps>(
    {} as IPaginationProps,
  );
  const [search, setSearch] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const response = await api.get(`/clusters`, {
          params: {
            pageIndex: currentPage - 1,
            pageSize: 21,
            search: search,
            type: 'exercise',
          },
        });

        setClustersData(response.data);
      } catch (error) {
        console.log(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    })();
  }, [search, currentPage]);

  const handleFilterModule = useCallback((value: string) => {
    setSearch(value);
    setCurrentPage(1);
  }, []);

  return (
    <Container>
      {loading && <LoaderBIO isVisible />}
      <HeaderSectionContainer padding="1rem 2rem">
        <h1>
          <GraduationCap weight="duotone" /> Exercícios em Vídeo
        </h1>
        <p>Aulas focadas em Resolução de Exercícios.</p>
      </HeaderSectionContainer>

      <HeaderSection>
        <Breadcrumbs
          icon={House}
          separator="/"
          route={[
            { title: 'Exercícios em Vídeo', link: '/exercicios-em-video' },
          ]}
        />
        <SearchContainer>
          <InputDebounceAdapter
            type="text"
            debounceTimeout={300}
            minLength={3}
            onChange={event => handleFilterModule(event.target.value)}
            placeholder="Busque por lista..."
          />
          <MagnifyingGlass weight="duotone" />
        </SearchContainer>
      </HeaderSection>

      <SectionContainer1>
        {clustersData.records?.map(cluster => (
          <>
            <CardUniversity key={cluster.id} to={`aulas/${cluster.slug}/!`}>
              <footer>
                <div>
                  <h5>{cluster.title}</h5>
                  <p>{cluster.progress.toFixed(0)}%</p>
                </div>
                <footer>
                  <ProgressBar
                    width="100%"
                    height="12px"
                    scrollArea={scrollRef}
                    percentage={cluster.progress.toFixed(0)}
                    rect
                    rectPadding="2px"
                    trackPathColor="#b7b7b730"
                    bgColor="#6befb0"
                    trackBorderColor="transparent"
                  />
                </footer>
              </footer>
            </CardUniversity>
          </>
        ))}
      </SectionContainer1>

      {clustersData.records?.length === 0 && <NotFoundRegister />}

      {clustersData.maxPages > 1 && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          count={clustersData.maxPages}
        />
      )}
    </Container>
  );
};

export default ModulosExercisesInVideo;
